let mobilePopupBarEl = null;
let suppressChartDismiss = false;
let suppressChartDismissTimer = null;
let mobileChartPopupUiReady = false;
const lastChartPointer = { x: 0, y: 0 };
let chartGestureIsTap = true;
let chartGestureTracking = false;
const TAP_MOVE_TOLERANCE = 10;
const chartGestureStart = { x: 0, y: 0 };

function isMobileChartTapMode() {
    const root = document.documentElement;
    const isTouchDevice = navigator.maxTouchPoints > 0 ||
        window.matchMedia?.('(any-pointer: coarse)')?.matches ||
        window.matchMedia?.('(pointer: coarse)')?.matches;
    if (!isTouchDevice) {
        return false;
    }
    if (root.classList.contains('desktop-landscape')) {
        return true;
    }
    return root.classList.contains('desktop-portrait-accepted');
}

function hideMainBlockHoverPopup() {
    const popup = document.querySelector('#main-block-hover-pop-up');
    if (popup) {
        popup.classList.remove('show', 'full');
    }
    mobilePopupBarEl = null;
}

function recordChartPointer(event) {
    const point = event.touches?.[0] || event.changedTouches?.[0] || event;
    if (point && Number.isFinite(point.clientX) && Number.isFinite(point.clientY)) {
        lastChartPointer.x = point.clientX;
        lastChartPointer.y = point.clientY;
    }
}

function initMobileChartPopupUi() {
    if (mobileChartPopupUiReady || !isMobileChartTapMode()) {
        return;
    }
    const chartWrapper = document.querySelector('#main-block .chart-wrapper');
    if (!chartWrapper) {
        return;
    }
    mobileChartPopupUiReady = true;
    chartWrapper.addEventListener('pointerdown', recordChartPointer, { passive: true });
    chartWrapper.addEventListener('touchstart', recordChartPointer, { passive: true });
    chartWrapper.addEventListener('pointerup', (event) => {
        if (!isMobileChartTapMode() || suppressChartDismiss) {
            return;
        }
        const popup = document.querySelector('#main-block-hover-pop-up');
        if (!popup || !popup.classList.contains('show')) {
            return;
        }
        if (event.target.closest('.chart-interaction-toggle, .fullscreen-toggle, .fullscreen-close, .rotate-move-switcher-container')) {
            return;
        }
        const scene = chartWrapper.querySelector('#main-scene');
        const canvas = scene?.canvas;
        if (canvas && (event.target === canvas || canvas.contains(event.target))) {
            hideMainBlockHoverPopup();
        }
    });

    const popup = document.querySelector('#main-block-hover-pop-up');
    if (popup) {
        popup.addEventListener('click', (event) => {
            if (!isMobileChartTapMode() || !mobilePopupBarEl) return;
            
            const component = mobilePopupBarEl.components['stock-bar'];
            if (!component) return;
            
            const stockData = component.enrichedStock || component.getResolvedStockData();
            
            if (window.MobileNav && window.MobileNav.openStockDetail) {
                window.MobileNav.openStockDetail(stockData, mobilePopupBarEl);
            } else {
                component.openStockChart(stockData);
            }
            
            hideMainBlockHoverPopup();
        });
    }

    window.addEventListener('scroll', () => {
        if (!isMobileChartTapMode()) return;
        const popupEl = document.querySelector('#main-block-hover-pop-up');
        if (popupEl && popupEl.classList.contains('show')) {
            hideMainBlockHoverPopup();
        }
    }, { capture: true, passive: true });

    let touchStartPageY = 0;
    let touchStartPageX = 0;

    window.addEventListener('touchstart', (e) => {
        if (!isMobileChartTapMode()) return;
        const touch = e.touches[0];
        if (touch) {
            touchStartPageY = touch.pageY;
            touchStartPageX = touch.pageX;
        }
    }, { passive: true });

    window.addEventListener('touchmove', (e) => {
        if (!isMobileChartTapMode()) return;
        const popupEl = document.querySelector('#main-block-hover-pop-up');
        if (!popupEl || !popupEl.classList.contains('show')) return;

        const touch = e.touches[0];
        if (touch) {
            const dy = touch.pageY - touchStartPageY;
            const dx = touch.pageX - touchStartPageX;
            if (Math.abs(dy) > 10 && Math.abs(dy) > Math.abs(dx)) {
                hideMainBlockHoverPopup();
            }
        }
    }, { passive: true });
}

function initChartGestureTracking() {
    document.addEventListener('touchstart', (event) => {
        if (!isMobileChartTapMode()) {
            return;
        }
        if (!(event.target instanceof Element) || !event.target.closest('#main-block .chart-wrapper')) {
            chartGestureTracking = false;
            return;
        }
        if (event.touches.length !== 1) {
            chartGestureIsTap = false;
            chartGestureTracking = false;
            return;
        }
        chartGestureTracking = true;
        chartGestureIsTap = true;
        chartGestureStart.x = event.touches[0].clientX;
        chartGestureStart.y = event.touches[0].clientY;
    }, { capture: true, passive: true });

    document.addEventListener('touchmove', (event) => {
        if (!chartGestureTracking || !chartGestureIsTap) {
            return;
        }
        const touch = event.touches[0];
        if (!touch) {
            return;
        }
        const dx = Math.abs(touch.clientX - chartGestureStart.x);
        const dy = Math.abs(touch.clientY - chartGestureStart.y);
        if (dx > TAP_MOVE_TOLERANCE || dy > TAP_MOVE_TOLERANCE) {
            chartGestureIsTap = false;
        }
    }, { capture: true, passive: true });

    document.addEventListener('touchend', () => {
        chartGestureTracking = false;
    }, { capture: true, passive: true });

    document.addEventListener('touchcancel', () => {
        chartGestureTracking = false;
        chartGestureIsTap = false;
    }, { capture: true, passive: true });
}

window.StockStormHideMainBlockHoverPopup = hideMainBlockHoverPopup;

document.addEventListener('DOMContentLoaded', () => {
    initMobileChartPopupUi();
    initChartGestureTracking();
});

AFRAME.registerComponent('stock-bar', {
    schema: {
        stockData: { type: 'string', default: '' },
        baseColor: { type: 'string', default: '#fff200' }
    },
    init: function () {
        const el = this.el;
        el.setAttribute('data-raycastable', '');
        this.isMmapBar = this.checkIsMmapBar();
        this.popup = null;
        this.polygonApiManager = null;
        this.enrichedStock = null;

        this.initializePolygonApi();

        this.isCurrentlyHovered = false;
        this.mouseX = 0;
        this.mouseY = 0;

        this._onMouseMove = this.mouseMoveListener.bind(this);
        window.addEventListener('mousemove', this._onMouseMove);

        el.addEventListener('mouseenter', async () => {
            if (isMobileChartTapMode()) {
                return;
            }
            this.isCurrentlyHovered = true;
            if (!this.isMmapBar) {
                el.setAttribute('material', 'opacity', `0.9`);
            }

            const stock = this.getResolvedStockData();

            await this.fetchTickerDetails(stock);
            this.showPopupV3(this.enrichedStock || stock);
        });

        el.addEventListener('mouseleave', () => {
            if (isMobileChartTapMode()) {
                return;
            }
            this.isCurrentlyHovered = false;
            if (!this.isMmapBar) {
                el.setAttribute('material', 'opacity', `0.65`);
            } else {
                el.setAttribute('material', 'opacity', `1`);
            }
            if (this.popup) {
                this.popup.remove();
                this.popup = null;
            }
            const hoverPopUpHTML = document.querySelector('#main-block-hover-pop-up')
            hoverPopUpHTML.classList.remove('show', 'full')
        });

        el.addEventListener('click', async () => {
            if (isMobileChartTapMode() && !chartGestureIsTap) {
                return;
            }

            const stock = this.enrichedStock || this.getResolvedStockData();

            if (isMobileChartTapMode()) {
                initMobileChartPopupUi();
                const popup = document.querySelector('#main-block-hover-pop-up');
                const isSameBar = mobilePopupBarEl === el;
                const isShowing = popup && popup.classList.contains('show');

                if (isSameBar && isShowing) {
                    hideMainBlockHoverPopup();
                    return;
                } else {
                    mobilePopupBarEl = el;
                    this.mouseX = lastChartPointer.x;
                    this.mouseY = lastChartPointer.y;
                    await this.fetchTickerDetails(stock);
                    this.showPopupV3(this.enrichedStock || stock);
                    
                    if (window.MobileNav && window.MobileNav.openStockDetail) {
                        window.MobileNav.openStockDetail(this.enrichedStock || stock, el);
                    } else {
                        this.openStockChart(this.enrichedStock || stock, true);
                    }

                    const scene = this.el.sceneEl || document.querySelector('a-scene');
                    if (scene) {
                        scene.emit('stock-selected', this.enrichedStock || stock);
                    }

                    suppressChartDismiss = true;
                    clearTimeout(suppressChartDismissTimer);
                    suppressChartDismissTimer = setTimeout(() => {
                        suppressChartDismiss = false;
                    }, 400);
                }
                return;
            }

            await this.selectStock(stock);
        });
    },

    selectStock: async function (stock, options = {}) {
        const resolvedStock = stock || this.enrichedStock || this.getResolvedStockData();
        const showPopup = options.showPopup !== false;

        await this.fetchTickerDetails(resolvedStock);
        const selectedStock = this.enrichedStock || resolvedStock;

        this.openStockChart(selectedStock, showPopup);

        const scene = this.el.sceneEl || document.querySelector('a-scene');
        if (scene) {
            scene.emit('stock-selected', selectedStock);
        }

        return selectedStock;
    },

    getResolvedStockData: function () {
        const fallback = {
            ticker: 'UNKNOWN',
            todaysChangePerc: 0,
            price: 0,
            volume: 0,
            tickerSummary: {
                name: 'UNKNOWN',
                primary_exchange: 'Unknown Exchange',
                market_cap: 0,
                previous_close: 0
            }
        };

        if (this.el && this.el.__stockData) {
            return this.el.__stockData;
        }

        const stockDataAttr = this.el && this.el.getAttribute ? this.el.getAttribute('stock-bar') : null;
        if (stockDataAttr && stockDataAttr.stockData) {
            try {
                const parsedAttr = JSON.parse(stockDataAttr.stockData);
                this.el.__stockData = parsedAttr;
                return parsedAttr;
            } catch (error) {
                if (__LOG_ERROR__) AppLog.error(`Failed to parse stockData from stock-bar attribute: ${error.message}`, stockDataAttr.stockData);
            }
        }

        try {
            if (__LOG_INFO__) AppLog.info('Raw stockData:', this.data.stockData);
            if (this.data.stockData) {
                const parsed = JSON.parse(this.data.stockData);
                this.el.__stockData = parsed;
                return parsed;
            }
        } catch (error) {
            if (__LOG_ERROR__) AppLog.error(`Failed to parse stockData for stock-bar: ${error.message}`, this.data.stockData);
        }

        return fallback;
    },

    checkIsMmapBar() {
        try {
            const visualizerEl = this.el.closest('[stock-cube-visualizer]');
            if (!visualizerEl || !visualizerEl.components) return false;
            const component = visualizerEl.components['stock-cube-visualizer'];
            return component && component.data && component.data.dataSource === 'mmap';
        } catch (e) {
            if (__LOG_WARN__) AppLog.warn('Failed to detect mmap chart for stock-bar', e);
            return false;
        }
    },

    async initializePolygonApi() {
        try {
            this.polygonApiManager = await PolygonAPIManager.create();
        } catch (error) {
            if (__LOG_ERROR__) AppLog.error('Failed to initialize PolygonAPIManager:', error.message);
        }
    },

    async fetchTickerDetails(stock) {
        stock.tickerSummary = stock.tickerSummary || {
            name: stock.ticker || 'UNKNOWN',
            primary_exchange: 'Unknown Exchange',
            market_cap: 0,
            previous_close: 0
        };
        if (__LOG_INFO__) AppLog.info(`Original tickerSummary for ${stock.ticker}:`, stock.tickerSummary);

        if (stock.tickerDetails && typeof stock.tickerDetails === 'object') {
            if (__LOG_INFO__) AppLog.info(`Using existing tickerDetails for ${stock.ticker} from stock object`);
            this.enrichedStock = { ...stock };
            return;
        }

        if (!this.polygonApiManager) {
            if (__LOG_WARN__) AppLog.warn('PolygonAPIManager not initialized, skipping ticker details fetch');
            this.enrichedStock = { ...stock };
            return;
        }

        const cacheKey = `ticker_${stock.ticker || 'UNKNOWN'}`;
        let tickerDetails = null;
        let cachedStock = null;

        // Check cache for stock data
        cachedStock = getCacheItem(cacheKey);
        if (__LOG_INFO__) AppLog.info(`Cached stock data for ${cacheKey}:`, cachedStock);

        if (cachedStock && cachedStock.tickerDetails && typeof cachedStock.tickerDetails === 'object') {
            tickerDetails = cachedStock.tickerDetails;
            stock = { ...cachedStock, ...stock };
        } else {
            if (__LOG_INFO__) AppLog.info(`No valid tickerDetails in cache for ${stock.ticker} (cachedStock: ${JSON.stringify(cachedStock)}), fetching from API`);
        }

        if (!tickerDetails) {
            try {
                const enriched = await this.polygonApiManager.enrichWithTickerDetails([stock], 10);
                if (__LOG_INFO__) AppLog.info(`PolygonAPIManager enriched data for ${stock.ticker}:`, enriched);

                tickerDetails = enriched[0]?.tickerDetails || {
                    name: stock.tickerSummary.name || stock.ticker || 'UNKNOWN',
                    primary_exchange: stock.tickerSummary.primary_exchange || 'Unknown Exchange',
                    market_cap: stock.tickerSummary.market_cap || 0,
                    previous_close: stock.tickerSummary.previous_close || 0,
                    list_date: 'N/A'
                };

                // Update tickerSummary only if incomplete
                if (stock.tickerSummary.name === stock.ticker || stock.tickerSummary.primary_exchange === 'Unknown Exchange') {
                    stock.tickerSummary = {
                        name: tickerDetails.name,
                        primary_exchange: tickerDetails.primary_exchange,
                        market_cap: tickerDetails.market_cap || stock.tickerSummary.market_cap,
                        previous_close: tickerDetails.previous_close || stock.tickerSummary.previous_close
                    };
                    if (__LOG_INFO__) AppLog.info(`Updated tickerSummary for ${stock.ticker}:`, stock.tickerSummary);
                }

                const updatedStock = {
                    ...cachedStock,
                    ...stock,
                    tickerSummary: { ...stock.tickerSummary },
                    tickerDetails
                };

                try {
                    setCacheItem(cacheKey, updatedStock, 1440); // 24 hours
                } catch (error) {
                    if (__LOG_ERROR__) AppLog.error(`❌ Failed to cache stock data for ${stock.ticker}:`, error.message);
                }
            } catch (error) {
                if (__LOG_ERROR__) AppLog.error(`❌ Error fetching tickerDetails for ${stock.ticker}:`, error.message);
                tickerDetails = {
                    name: stock.tickerSummary.name || stock.ticker || 'UNKNOWN',
                    primary_exchange: stock.tickerSummary.primary_exchange || 'Unknown Exchange',
                    market_cap: stock.tickerSummary.market_cap || 0,
                    previous_close: stock.tickerSummary.previous_close || 0,
                    list_date: 'N/A'
                };

                if (stock.tickerSummary.name === stock.ticker || stock.tickerSummary.primary_exchange === 'Unknown Exchange') {
                    stock.tickerSummary = {
                        name: tickerDetails.name,
                        primary_exchange: tickerDetails.primary_exchange,
                        market_cap: tickerDetails.market_cap || stock.tickerSummary.market_cap,
                        previous_close: tickerDetails.previous_close || stock.tickerSummary.previous_close
                    };
                    if (__LOG_INFO__) AppLog.info(`Updated tickerSummary for ${stock.ticker} (fallback):`, stock.tickerSummary);
                }

                const updatedStock = {
                    ...cachedStock,
                    ...stock,
                    tickerSummary: { ...stock.tickerSummary },
                    tickerDetails
                };

                try {
                    setCacheItem(cacheKey, updatedStock, 1440);
                } catch (cacheError) {
                    if (__LOG_ERROR__) AppLog.error(`❌ Failed to cache fallback stock data for ${stock.ticker}:`, cacheError.message);
                }
            }
        }

        this.enrichedStock = {
            ...stock,
            tickerSummary: { ...stock.tickerSummary },
            tickerDetails
        };
        if (__LOG_INFO__) AppLog.info('Enriched stock after update:', this.enrichedStock);
    },

    getDataSource: function () {
        try {
            const visualizerEl = this.el.closest('[stock-cube-visualizer]');
            if (!visualizerEl || !visualizerEl.components) return null;
            const component = visualizerEl.components['stock-cube-visualizer'];
            return component && component.data ? component.data.dataSource : null;
        } catch (e) {
            return null;
        }
    },

    formatLargeNumber: function (num) {
        if (!Number.isFinite(num)) return '0';
        const absNum = Math.abs(num);
        if (absNum >= 1.0e+12) return (num / 1.0e+12).toFixed(1) + ' T';
        if (absNum >= 1.0e+9) return (num / 1.0e+9).toFixed(1) + ' B';
        if (absNum >= 1.0e+6) return (num / 1.0e+6).toFixed(1) + ' M';
        if (absNum >= 1.0e+3) return (num / 1.0e+3).toFixed(1) + ' K';
        return num.toFixed(2);
    },

    showPopupV3: function (stock) {
        const hoverPopUpHTML = document.querySelector('#main-block-hover-pop-up')
        if (!hoverPopUpHTML) return;

        const tickerHTML = hoverPopUpHTML.querySelector('.short-form .ticker .value')
        const exchangerHTML = hoverPopUpHTML.querySelector('.short-form .exchange .value')
        const changeHTML = hoverPopUpHTML.querySelector('.short-form .change .value')
        const priceHTML = hoverPopUpHTML.querySelector('.short-form .price .value')

        const dollarVolumeRow = hoverPopUpHTML.querySelector('.short-form .dollar-volume');
        const volumeRow = hoverPopUpHTML.querySelector('.short-form .volume');
        const marketCapRow = hoverPopUpHTML.querySelector('.short-form .market-cap');
        const shortInterestRow = hoverPopUpHTML.querySelector('.short-form .short-interest');
        const dividendRow = hoverPopUpHTML.querySelector('.short-form .dividend');

        const dollarVolumeHTML = dollarVolumeRow ? dollarVolumeRow.querySelector('.value') : null;
        const volumeHTML = volumeRow ? volumeRow.querySelector('.value') : null;
        const marketCapHTML = marketCapRow ? marketCapRow.querySelector('.value') : null;
        const shortInterestHTML = shortInterestRow ? shortInterestRow.querySelector('.value') : null;
        const dividendHTML = dividendRow ? dividendRow.querySelector('.value') : null;

        tickerHTML.textContent = stock.ticker || 'Unknown'
        const exchangeValue = stock.tickerDetails?.primary_exchange ||
                              stock.tickerSummary?.primary_exchange ||
                              stock.primary_exchange ||
                              null;
        exchangerHTML.textContent = (exchangeValue && exchangeValue !== 'Unknown Exchange' && exchangeValue.trim() !== '')
            ? exchangeValue
            : 'Unknown';
        changeHTML.textContent = (stock.todaysChangePerc || 0).toFixed(1) + '%'; 
        const price2 = stock.day && stock.day.c ? stock.day.c : stock.price || 0;
        const priceParts = price2.toFixed(2).split('.');
        const formattedPrice = priceParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + priceParts[1];
        priceHTML.textContent = `$${formattedPrice}`

        const dataSource = this.getDataSource();

        const setVisible = (row, visible) => {
            if (row) row.style.display = visible ? 'flex' : 'none';
        };

        setVisible(dollarVolumeRow, false);
        setVisible(volumeRow, false);
        setVisible(marketCapRow, false);
        setVisible(shortInterestRow, false);
        setVisible(dividendRow, false);


        if (dataSource === 'top-dollar-vol' || dataSource === 'top-dollar-vol-sec') {
            const volume = stock.cumulative_volume || 0;
            const dollarVol = (stock.cumulative_dollar_volume || stock.dollarVolume) 
                ? (stock.cumulative_dollar_volume || stock.dollarVolume)
                : (price2 * volume);
            
            if (dollarVolumeHTML) dollarVolumeHTML.textContent = `$${this.formatLargeNumber(dollarVol)}`;
            setVisible(dollarVolumeRow, true);
        }

        else if (dataSource === 'top-vol' || dataSource === 'top-vol-sec') {
            const displayVol = stock.cumulative_volume || (stock.day && stock.day.v ? stock.day.v : stock.volume) || 0;
            if (volumeHTML) volumeHTML.textContent = this.formatLargeNumber(displayVol);
            setVisible(volumeRow, true);
        }

        else if (dataSource === 'mmap') {
            const mktCap = stock.market_cap || stock.tickerSummary?.market_cap || stock.tickerDetails?.market_cap || 0;
            if (marketCapHTML) marketCapHTML.textContent = `$${this.formatLargeNumber(mktCap)}`;
            setVisible(marketCapRow, true);
        }

        else if (dataSource === 'sip' || dataSource === 'sip-sec') {
            const sip = stock.short_interest_pct || 0;
            if (shortInterestHTML) shortInterestHTML.textContent = `${sip.toFixed(1)}%`;
            setVisible(shortInterestRow, true);
        }

        else if (dataSource === 'dividend' || dataSource === 'dividend-sec') {
            const yieldPct = stock.trail_1y_div_yield_pct || 0;
            const divAmount = stock.trail_1y_div;
            if (dividendHTML) dividendHTML.textContent = `$${divAmount.toFixed(2)} (${yieldPct.toFixed(1)}%)`;
            setVisible(dividendRow, true);
        }

        if (isMobileChartTapMode() && (!this.mouseX || !this.mouseY)) {
            return;
        }

        hoverPopUpHTML.classList.add('show')
        if (this.mouseX && this.mouseY) {
            hoverPopUpHTML.style.position = 'fixed'
            hoverPopUpHTML.style.top = this.mouseY + 10 + 'px'
            hoverPopUpHTML.style.left = this.mouseX + 10 +'px'

            const container = document.getElementById('main-block');
            if (container) {
                const containerRect = container.getBoundingClientRect();
                const middleX = containerRect.left + containerRect.width / 2;
                const middleY = containerRect.top + containerRect.height / 2;
                if (this.mouseX >= middleX && this.mouseY <= middleY) {
                    hoverPopUpHTML.style.transform = 'translate(-100%, 0)'; // left
                    hoverPopUpHTML.style.left = this.mouseX - 10 +'px'
                } else if (this.mouseX >= middleX && this.mouseY > middleY) {
                    hoverPopUpHTML.style.transform = 'translate(-100%, -100%)'; // left-bottom
                    hoverPopUpHTML.style.top = this.mouseY - 10 + 'px'
                    hoverPopUpHTML.style.left = this.mouseX - 10 +'px'
                } else if (this.mouseX < middleX && this.mouseY > middleY) {
                    hoverPopUpHTML.style.transform = 'translate(0, -100%)'; // bottom
                    hoverPopUpHTML.style.top = this.mouseY - 10 + 'px'
                } else {
                    hoverPopUpHTML.style.transform = 'translate(0, 0)'; // default (right)
                }
            }
        } else {
            hoverPopUpHTML.style.position = 'absolute'
            hoverPopUpHTML.style.top = '150px'
            hoverPopUpHTML.style.left = '30px'
        }

        if (exchangerHTML.textContent === 'Unknown') exchangerHTML.classList.add('no-data')
        else exchangerHTML.classList.remove('no-data')
    },

    openStockChart: function (stock, showPopup = true) {
        const leftPanel = document.getElementById('large-left-panel');
        let leftContent = null;
        if (leftPanel) {
            leftContent = document.getElementById('large-left-panel-content');
            if (leftContent) {
                leftContent.replaceChildren();
            }
        }

        const stockChart = document.getElementById('stock-chart');
        if (!stockChart) {
            if (__LOG_INFO__) AppLog.info('No default stock-chart found');
            return;
        }
        let currentDataInterval
        let currentShowEventsStatus = false
        const existingUniversal = stockChart.getAttribute('tradingview-universal-chart');
        if (existingUniversal) {
            if (existingUniversal.width != null && stockChart.dataset.chartWidth == null) {
                stockChart.dataset.chartWidth = existingUniversal.width;
            }
            if (existingUniversal.height != null && stockChart.dataset.chartHeight == null) {
                stockChart.dataset.chartHeight = existingUniversal.height;
            }
            if (existingUniversal.dataInterval) {
                currentDataInterval = existingUniversal.dataInterval
            }
            if (existingUniversal.showEvents) {
                currentShowEventsStatus = existingUniversal.showEvents
            }
        }
        const universalType = existingUniversal && existingUniversal.type ? existingUniversal.type : (stockChart.hasAttribute('tradingview-universal-chart') ? (stockChart.getAttribute('tradingview-universal-chart') || {}).type : null);
        const dataInterval = currentDataInterval || '1y';
        let chartConfig = {};
        
        let newSecondarySeriesType = 'volume'
        const dataSource = this.getDataSource();
        if (dataSource === 'sip' || dataSource === 'sip-sec') newSecondarySeriesType = 'sip'
        if (dataSource === 'sip' || dataSource === 'sip-sec') newSecondarySeriesType = 'sip'
        if (dataSource === 'dividend' || dataSource === 'dividend-sec')  newSecondarySeriesType = 'dividend'

        stockChart.setAttribute('tradingview-universal-chart', {
            stockData: JSON.stringify(stock),
            dataInterval: dataInterval,
            type: universalType,
            showEvents: currentShowEventsStatus,
            secondarySeriesType: newSecondarySeriesType,

        });
        const rightAverageVolumeEl = document.querySelector('#right-average-volume');
        const rightAverageVolumeBarEl = document.querySelector('#right-average-volume .active-bar');
        if (__LOG_INFO__) AppLog.info('ks volume:', dataInterval, stock, rightAverageVolumeEl, rightAverageVolumeBarEl)
        if (rightAverageVolumeEl && rightAverageVolumeBarEl) {
            const stockVolume = stock.daypart_relative_volume_percentage || 0;
            const width = Math.min(Math.max(0, stockVolume / 2), 100)
            if (__LOG_INFO__) AppLog.info('ks volume2:', stockVolume, width)
            rightAverageVolumeBarEl.style.width = `${width}%`;
            rightAverageVolumeEl.classList.add('initialized')
            if (dataInterval === '1D' || dataInterval === '1d') {
                rightAverageVolumeEl.classList.add('show')
            } else {
                rightAverageVolumeEl.classList.remove('show')
            }
        }

        const formatMarketCap = (marketCap) => {
            if (!marketCap) return 'N/A';
            const trillion = 1e12;
            const billion = 1e9;
            const million = 1e6;
            if (marketCap >= trillion) return `$${(marketCap / trillion).toFixed(2)}T`;
            if (marketCap >= billion) return `$${(marketCap / billion).toFixed(2)}B`;
            if (marketCap >= million) return `$${(marketCap / million).toFixed(2)}M`;
            return `$${marketCap.toLocaleString()}`;
        };

        const isWarrantByName = (stock.ticker || '').endsWith('W') && /warrant/i.test(stock.tickerDetails?.name || stock.tickerSummary?.name || '');
        const isDerivative = stock.tickerDetails?.type === 'WARRANT' || stock.tickerDetails?.type === 'OPTION' || isWarrantByName;
        const marketCap = isDerivative && stock.tickerDetails?.underlyingDetails
            ? stock.tickerDetails.underlyingDetails.market_cap
            : (stock.tickerDetails?.market_cap || stock.tickerSummary?.market_cap || 0);
        let range52Week = stock.range52Week || 
                         stock.performanceData?.range52Week ||
                         stock.tickerDetails?.range52Week || 
                         null;
        
        if (!range52Week && stock.ticker && window.RightPanelProxyAPIManager) {
            try {
                const apiManager = window.RightPanelProxyAPIManager.instance || null;
                if (apiManager && apiManager.isInitialized) {
                    const cachedPerformance = apiManager.getCachedData('performance', stock.ticker);
                    if (cachedPerformance && cachedPerformance.range52Week) {
                        range52Week = cachedPerformance.range52Week;
                    }
                } 
            } catch (e) {
                if (__LOG_INFO__) AppLog.info('Could not get cached performance data from RightPanelProxyAPIManager:', e);
            }
        }
        
        const high52Week = range52Week?.high || 
                          stock.tickerDetails?.high_52_week || 
                          stock.tickerDetails?.year_high ||
                          stock.tickerDetails?.high || 
                          null;
        const low52Week = range52Week?.low || 
                         stock.tickerDetails?.low_52_week || 
                         stock.tickerDetails?.year_low ||
                         stock.tickerDetails?.low || 
                         null;
        
        const high52WeekText = (high52Week != null && high52Week > 0) ? (() => {
            const parts = high52Week.toFixed(2).split('.');
            return `$${parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')}.${parts[1]}`;
        })() : 'N/A';
        const low52WeekText = (low52Week != null && low52Week > 0) ? (() => {
            const parts = low52Week.toFixed(2).split('.');
            return `$${parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')}.${parts[1]}`;
        })() : 'N/A';
        const price = stock.day?.c || stock.price || 0;
        const activeInterval = (typeof getCacheItem === 'function' ? getCacheItem('data-interval') : null) || '1D';
        const intervalLower = activeInterval.toLowerCase();
        let volume;
        if (intervalLower === '1d') {
            volume = stock.cumulative_volume || 0;
        } else if (intervalLower === '5d' || intervalLower === '1m') {
            volume = stock.volume || 0;
        } else {
            volume = stock.cumulative_volume || 0;
        }
        const companyname = document.createElement('a-text');
        companyname.setAttribute('value', stock.tickerDetails?.name || stock.tickerSummary?.name || stock.ticker || 'UNKNOWN');
        companyname.setAttribute('position', '-2.4 -3.95 0.5');
        companyname.setAttribute('align', 'center');
        companyname.setAttribute('color', 'white');
        companyname.setAttribute('scale', '0.9 0.9 0.9');
        companyname.setAttribute('width', 4.5);
        companyname.setAttribute('shader', 'msdf');
        companyname.setAttribute('font', 'roboto');
        companyname.setAttribute('negate', 'true');
        companyname.setAttribute('alphaTest', '0.5');

        const labels = document.createElement('a-text');
        labels.setAttribute('value',
            `Ticker:\n` +
            `Exchange:\n` +
            `Change:\n` +
            `Price:\n` +
            `Volume:\n` +
            `Market Cap:\n` +
            `52-Wk High:\n` +
            `52-Wk Low:\n` +
            `Listed:`
        );
        labels.setAttribute('position', '-2.5 -4.8 0.5');
        labels.setAttribute('align', 'right');
        labels.setAttribute('color', 'yellow');
        labels.setAttribute('scale', '0.9 0.9 0.9');
        labels.setAttribute('width', '3.5');
        labels.setAttribute('shader', 'msdf');
        labels.setAttribute('font', 'roboto');
        labels.setAttribute('negate', 'true');
        labels.setAttribute('alphaTest', '0.5');

        const values = document.createElement('a-text');
        values.setAttribute('value',
            `${stock.ticker || 'UNKNOWN'}\n` +
            `${stock.tickerDetails?.primary_exchange || stock.tickerSummary?.primary_exchange || 'Unknown Exchange'}\n` +
            `${(stock.todaysChangePerc || 0).toFixed(1)}%\n` +
            `$${price.toLocaleString()}\n` +
            `${volume.toLocaleString()}\n` +
            `${formatMarketCap(marketCap)}\n` +
            `${high52WeekText}\n` +
            `${low52WeekText}\n` +
            `${stock.tickerDetails?.list_date || 'N/A'}`
        );
        values.setAttribute('position', '-2.4 -4.8 0.5');
        values.setAttribute('align', 'left');
        values.setAttribute('color', 'white');
        values.setAttribute('scale', '0.9 0.9 0.9');
        values.setAttribute('width', '3.5');
        values.setAttribute('shader', 'msdf');
        values.setAttribute('font', 'roboto');
        values.setAttribute('negate', 'true');
        values.setAttribute('alphaTest', '0.5');

        let exchange = stock.tickerDetails?.primary_exchange || stock.tickerSummary?.primary_exchange || 'Unknown Exchange';
        if (exchange === "New York Stock Exchange") {
            exchange = "NYSE";
        }
        const formattedTicker = `${exchange}:${stock.ticker || 'UNKNOWN'}`;
        if (window._tickerNewsInstance) {
            window._tickerNewsInstance.setTicker(formattedTicker);
        }

        const hoverPopUpHTML = document.querySelector('#main-block-hover-pop-up')
        const dateHtml = hoverPopUpHTML.querySelector('.full-form .date')
        const fullNameHTML = hoverPopUpHTML.querySelector('.full-form .full-name h4')
        const tickerHTML = hoverPopUpHTML.querySelector('.full-form .ticker .value')
        const exchangerHTML = hoverPopUpHTML.querySelector('.full-form .exchange .value')
        const changeHTML = hoverPopUpHTML.querySelector('.full-form .change .value')
        const priceHTML = hoverPopUpHTML.querySelector('.full-form .price .value')
        const volumeHTML = hoverPopUpHTML.querySelector('.full-form .volume .value')
        const fullDollarVolumeRow = hoverPopUpHTML.querySelector('.full-form .dollar-volume')
        const fullDollarVolumeHTML = hoverPopUpHTML.querySelector('.full-form .dollar-volume .value')
        const marketHTML = hoverPopUpHTML.querySelector('.full-form .market .value')
        const shortInterestRow = hoverPopUpHTML.querySelector('.full-form .short-interest')
        const shortInterestHTML = hoverPopUpHTML.querySelector('.full-form .short-interest .value')
        const dividendRow = hoverPopUpHTML.querySelector('.full-form .dividend')
        const dividendHTML = hoverPopUpHTML.querySelector('.full-form .dividend .value')
        const w52HeightHTML = hoverPopUpHTML.querySelector('.full-form .w52-height .value')
        const w52LowHTML = hoverPopUpHTML.querySelector('.full-form .w52-low .value')

        
        dateHtml.textContent = ''
        try {
            dateHtml.textContent = this.getDateInFormatAsOf(stock.timestamp)
        } catch (e) {
            if (__LOG_ERROR__) AppLog.error("Error formatting date:", e);
        }
        
        fullNameHTML.textContent = stock.tickerDetails?.name || stock.tickerSummary?.name || stock.ticker || 'Unknown'
        tickerHTML.textContent = stock.ticker || 'Unknown'
        const exchangeValueFull = stock.tickerDetails?.primary_exchange || 
                                  stock.tickerSummary?.primary_exchange || 
                                  stock.primary_exchange || 
                                  null;
        exchangerHTML.textContent = (exchangeValueFull && exchangeValueFull !== 'Unknown Exchange' && exchangeValueFull.trim() !== '') 
            ? exchangeValueFull 
            : 'Unknown';
        changeHTML.textContent = (stock.todaysChangePerc || 0).toFixed(1) + '%'
        const priceParts = price.toFixed(2).split('.');
        const formattedPrice = priceParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + priceParts[1];
        priceHTML.textContent = `$${formattedPrice}`
        volumeHTML.textContent = volume.toLocaleString()

        if (fullDollarVolumeRow && fullDollarVolumeHTML) {
            if (dataSource === 'top-dollar-vol' || dataSource === 'top-dollar-vol-sec') {
                const dollarVol = (stock.cumulative_dollar_volume || stock.dollarVolume) 
                    ? (stock.cumulative_dollar_volume || stock.dollarVolume)
                    : (price * volume);
                fullDollarVolumeHTML.textContent = `$${this.formatLargeNumber(dollarVol)}`;
                fullDollarVolumeRow.style.display = 'flex';
            } else {
                fullDollarVolumeRow.style.display = 'none';
            }
        }

        if (dataSource === 'top-vol' || dataSource === 'top-vol-sec') {
             let displayVol;
             if (intervalLower === '1d') {
                 displayVol = stock.cumulative_volume || 0;
             } else if (intervalLower === '5d' || intervalLower === '1m') {
                 displayVol = stock.volume || 0;
             } else {
                 displayVol = stock.cumulative_volume || (stock.day && stock.day.v ? stock.day.v : stock.volume) || 0;
             }
             volumeHTML.textContent = this.formatLargeNumber(displayVol);
        } else {
             volumeHTML.textContent = volume.toLocaleString();
        }

        if (dataSource === 'mmap') {
            const mktCap = stock.market_cap || stock.tickerSummary?.market_cap || stock.tickerDetails?.market_cap || 0;
            marketHTML.textContent = `$${this.formatLargeNumber(mktCap)}`;
        } else {
            marketHTML.textContent = formatMarketCap(marketCap)
        }
        
        if (shortInterestRow && shortInterestHTML) {
            if (dataSource === 'sip' || dataSource === 'sip-sec') {
                const sip = stock.short_interest_pct || 0;
                shortInterestHTML.textContent = `${sip.toFixed(1)}%`;
                shortInterestRow.style.display = 'flex';
            } else {
                shortInterestRow.style.display = 'none';
            }
        }

        if (dividendRow && dividendHTML) {
            if (dataSource === 'dividend' || dataSource === 'dividend-sec') {
                const yieldPct = stock.trail_1y_div_yield_pct || 0;
                const divAmount = stock.trail_1y_div !== undefined ? stock.trail_1y_div : (yieldPct / 100) * price;
                dividendHTML.textContent = `$${divAmount.toFixed(2)} (${yieldPct.toFixed(1)}%)`;
                dividendRow.style.display = 'flex';
            } else {
                dividendRow.style.display = 'none';
            }
        }


        w52HeightHTML.textContent = high52WeekText
        w52LowHTML.textContent = low52WeekText

        if (fullNameHTML.textContent === 'Unknown') fullNameHTML.classList.add('no-data')
        else fullNameHTML.classList.remove('no-data')

        if (exchangerHTML.textContent === 'Unknown') exchangerHTML.classList.add('no-data')
        else exchangerHTML.classList.remove('no-data')

        if (w52HeightHTML.textContent === 'N/A') w52HeightHTML.classList.add('no-data')
        else w52HeightHTML.classList.remove('no-data')

        if (w52LowHTML.textContent === 'N/A') w52LowHTML.classList.add('no-data')
        else w52LowHTML.classList.remove('no-data')

        if (showPopup) hoverPopUpHTML.classList.add('show', 'full')

       
        if (showPopup) hoverPopUpHTML.classList.add('loading-logo');
        if (showPopup && window.CompanyIconAPIManager && stock.ticker) {
            (async () => {
                try {
                    let apiManager = window.CompanyIconAPIManager.instance;
                    if (!apiManager) {
                        apiManager = await window.CompanyIconAPIManager.create();
                    }
                    
                    const logoUrl = await apiManager.loadIcon(stock.ticker);
                    if (logoUrl) {
                        const logoImg = hoverPopUpHTML.querySelector('.full-form .full-name img');

                        if (!logoImg) return;
                        logoImg.onload = () => hoverPopUpHTML.classList.remove('loading-logo');
                        logoImg.src = logoUrl;
                    }
                } catch (e) {
                    if (__LOG_WARN__) AppLog.warn('[stock-bar] Failed to load company icon:', e);
                }
            })();
        }

        const sceneEl = this.el.sceneEl || document.querySelector('a-scene');
        if (sceneEl && stock.ticker) {
            const update52WeekData = (event) => {
                if (event.detail && event.detail.ticker === stock.ticker && event.detail.range52Week) {
                    const range52Week = event.detail.range52Week;
                    if (range52Week.high != null && range52Week.low != null && range52Week.high > 0 && range52Week.low > 0) {
                        const highParts = range52Week.high.toFixed(2).split('.');
                        const high52WeekText = `$${highParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')}.${highParts[1]}`;
                        const lowParts = range52Week.low.toFixed(2).split('.');
                        const low52WeekText = `$${lowParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')}.${lowParts[1]}`;
                        
                        w52HeightHTML.textContent = high52WeekText;
                        w52LowHTML.textContent = low52WeekText;
                        
                        if (w52HeightHTML.textContent === 'N/A') w52HeightHTML.classList.add('no-data')
                        else w52HeightHTML.classList.remove('no-data')
                        
                        if (w52LowHTML.textContent === 'N/A') w52LowHTML.classList.add('no-data')
                        else w52LowHTML.classList.remove('no-data')
                                                
                        sceneEl.removeEventListener('performance-data-updated', update52WeekData);
                    }
                }
            };
            sceneEl.addEventListener('performance-data-updated', update52WeekData);
            
            setTimeout(() => {
                sceneEl.removeEventListener('performance-data-updated', update52WeekData);
            }, 10000);
        }

        const rightContainer = document.getElementById('right-container');
        if (rightContainer) {
            const headerInput = rightContainer.querySelector('.header-row .select-wrapper input');
            if (headerInput) {
                const stockName = stock.tickerDetails?.name || stock.tickerSummary?.name || stock.ticker || 'Unknown';
                headerInput.value = stockName;
            }

            const chartWrapper = rightContainer.querySelector('.chart-wrapper');
            if (chartWrapper) {
                const paragraphs = chartWrapper.querySelectorAll('p');
                
                let exchange = stock.tickerDetails?.primary_exchange || stock.tickerSummary?.primary_exchange || 'Unknown Exchange';
                if (exchange === "New York Stock Exchange") {
                    exchange = "NYSE";
                }
                const ticker = stock.ticker || 'UNKNOWN';
                const exchangeTicker = `${exchange}:${ticker}`;
                
                const changePerc = stock.todaysChangePerc || 0;
                const changeSign = changePerc >= 0 ? '+' : '';
                const priceFormatted = `$${price.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
                const changeFormatted = `${changeSign}${changePerc.toFixed(2)}%`;
                
                const previousClose = stock.tickerDetails?.previous_close || stock.tickerSummary?.previous_close || stock.previous_close;
                let absoluteChange = 0;
                if (previousClose && previousClose > 0) {
                    absoluteChange = price - previousClose;
                } else if (changePerc !== 0) {
                    absoluteChange = (changePerc * price) / 100;
                }
                const absoluteChangeFormatted = `${changeSign}${Math.abs(absoluteChange).toFixed(2)}`;
                
                const now = new Date();
                const timeString = now.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true });
                const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
                const timezoneAbbr = timezone.includes('Eastern') ? 'EDT' : timezone.includes('Pacific') ? 'PDT' : timezone.includes('Central') ? 'CDT' : '';
                const asOfText = `As of ${timeString} ${timezoneAbbr}`;

                if (paragraphs.length >= 1) {
                    const stockName = stock.tickerDetails?.name || stock.tickerSummary?.name || stock.ticker || 'Unknown';
                    paragraphs[0].innerHTML = `<b>${stockName}</b> ${exchangeTicker}`;
                }
                if (paragraphs.length >= 2) {
                    paragraphs[1].innerHTML = `<b>${priceFormatted}</b> ${absoluteChangeFormatted} (${changeFormatted}) Today`;
                }
                if (paragraphs.length >= 3) {
                    paragraphs[2].textContent = asOfText;
                }
            }
        }
    },
    
    getDateInFormatAsOf(originalDataString) {
        if (!originalDataString) return ''

        let isETTimeZone = true;
        const rawSettings = localStorage.getItem('mainSettings');
        if (rawSettings) {
            try {
                const parsed = JSON.parse(rawSettings);
                if (parsed?.value?.isETTimeZone === false) {
                    isETTimeZone = false;
                }
            } catch (e) {
                if (__LOG_ERROR__) AppLog.error("Failed to parse settings", e);
            }
        }

        const cleanIso = originalDataString.trim().replace(/\s[A-Z]{3,4}$/, '').replace(' ', 'T');

        let date;
        if (isETTimeZone) {
            date = new Date(cleanIso);
        } else {
            const tempDate = new Date(cleanIso);
            const etOffsetDate = new Date(tempDate.toLocaleString('en-US', { timeZone: 'America/New_York' }));
            const diff = tempDate - etOffsetDate;
            date = new Date(tempDate.getTime() + diff);
        }

        const options = {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
        };

        if (!isETTimeZone) {
            options.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        }

        const formatter = new Intl.DateTimeFormat('en-US', options);

        return isNaN(date.getTime()) ? '' : `As of ${formatter.format(date)}`;
    },
    

    mouseMoveListener: function (e) {
        this.mouseX = e.clientX;
        this.mouseY = e.clientY;
    },
    
    
    tick: function () {
        if (!this.isCurrentlyHovered || !this.mouseX || !this.mouseY) return;

        const elUnder = document.elementFromPoint(this.mouseX, this.mouseY);
        const scene = this.el.sceneEl;
        const canvas = scene ? scene.canvas : null;
        const popup = document.querySelector('#main-block-hover-pop-up');

        if (elUnder && canvas && elUnder !== canvas) {
            const isPopup = popup && (elUnder === popup || popup.contains(elUnder));
            if (!isPopup) {
                this.el.emit('mouseleave');
            }
        }
    },

    remove() {
        window.removeEventListener('mousemove', this._onMouseMove);
    },
    
});
